var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#0857C3",
    stroke: "#0857C3",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1056 12.0313L11.651 10.6107C11.5458 10.5676 11.433 10.5455 11.3191 10.5455C11.2052 10.5455 11.0924 10.5676 10.9871 10.6107L7.53258 12.0313C7.21051 12.1627 7 12.4735 7 12.818C7 16.3428 9.06013 18.7791 10.9853 19.5711C11.1976 19.6581 11.4369 19.6581 11.6492 19.5711C13.1912 18.9372 15.6364 16.7477 15.6364 12.818C15.6364 12.4735 15.4259 12.1627 15.1056 12.0313ZM11.32 18.4702L11.3182 11.7046L14.483 13.0062C14.4237 15.6947 13.0059 17.6427 11.32 18.4702Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2763 6.09335L19.0379 8.01583C19.2086 8.44792 19.5511 8.78949 19.9823 8.96028L21.9048 9.72181C22.0317 9.7722 22.0317 9.95138 21.9048 10.0018L19.9823 10.7633C19.5502 10.9341 19.2086 11.2766 19.0379 11.7078L18.2763 13.6321C18.2259 13.759 18.0467 13.759 17.9964 13.6321L17.2348 11.7096C17.064 11.2775 16.7215 10.936 16.2904 10.7652L14.3679 10.0036C14.241 9.95325 14.241 9.77407 14.3679 9.72367L16.2904 8.96214C16.7225 8.79136 17.064 8.44886 17.2348 8.0177L17.9964 6.09521C18.0467 5.96829 18.2259 5.96829 18.2763 6.09521L18.2763 6.09335Z",
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8322 21.7889L16.249 22.3712C15.8931 22.5018 15.6118 22.7637 15.4712 23.0935L14.844 24.5636C14.8025 24.6607 14.655 24.6607 14.6135 24.5636L13.9863 23.0935C13.8457 22.763 13.5636 22.5018 13.2086 22.3712L11.6238 21.7889C11.5193 21.7504 11.5193 21.6133 11.6238 21.5748L13.207 20.9924C13.5629 20.8618 13.8442 20.5999 13.9848 20.2702L14.6119 18.8001C14.6534 18.703 14.801 18.703 14.8425 18.8001L15.4697 20.2702C15.6103 20.6006 15.8924 20.8618 16.2474 20.9924L17.8307 21.5748C17.9352 21.6133 17.9352 21.7504 17.8307 21.7889H17.8322Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiProfileIcon);
export default __webpack_public_path__ + "static/media/AiProfileIcon.1646f4141b2e5c996dc33d5e9408ba3b.svg";
export { ForwardRef as ReactComponent };